<template>
  <div>
    <page-header title="帮助中心" />
    <div class="help-center">
      <div
        class="item-container"
        @click="handleNavigationClick('help-detail', item)"
        v-for="(item, index) in articleList"
        :key="index"
      >
        <div class="list-item">
          <div>{{ item.title }}</div>
          <img src="../../../assets/into_icon@3x.png" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from '@/components/header.vue';
import User from '@/api/user';
export default {
  data() {
    return {
      articleList: [],
      page: 1,
      totalPages: '',
    };
  },

  created() {
    this.loadArticleList();
  },

  methods: {
    handleNavigationClick(name, item) {
      this.$router.push({
        name,
        params: {
          articleId: item.articleId,
        },
        query: {
          title: item.title,
        },
      });
    },

    async loadArticleList() {
      try {
        const { data: res } = await User.loadArticleList({});
        if (res.code == 0) {
          if (res.data.list.length === 0) {
            return;
          }

          this.articleList = this.articleList.concat(res.data.list);
          this.page = res.data.page;
          this.totalPages = res.data.totalPages;
        }
      } catch (e) {
        console.log(e);
      }
    },
  },

  components: {
    PageHeader,
  },
};
</script>
<style scoped lang="sass" src="./index.sass"></style>
